(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('ActivitiesService', ActivitiesService);

    function ActivitiesService(lodash, GenericModel, $rootScope) {
        var mem = {};

        return {
            init: init,
            sync: sync,
            destroy: destroy,
            discard: discard,
            selectType: selectType,
            getActivityType: getActivityType,
            refreshActivities: refreshActivities,
            save: save,
            setModel: setModel,
            inputOnChange: inputOnChange,
            getAttachmentOptions: getAttachmentOptions
        };

        function init(vm, options) {
            sync(vm);
            mem.activities = [];
            mem.options = options;
            lodash.set(mem.options, 'inputOptions.onChangeInstructions', [
                {name: 'sel_email_from', type: 'setSignature'}
            ]);

            lodash.set(mem.options, 'inputOptions.signatureSettings', {
                fieldName: 'txtbox_description'
            });

            prepareInputData();
            initLoadAttachments();

            if (lodash.has(mem, 'options.activityTypes')) {
                selectType(mem.options.activityTypes[0]);
            }
        }

        function initLoadAttachments() {
            // console.log('initLoadAttachments', mem.options);
            //mem.inputData.model.attachments
            if (lodash.has(mem.options, 'attachmentOptions.preattached')) {
                mem.options.attachmentOptions.preattached.loading = true;
                const model = new GenericModel(mem.options.attachmentOptions.preattached.datasource.url);
                const method = lodash.get(mem.options.attachmentOptions.preattached.datasource, 'method', 'create');
                const datasourceModel = lodash.get(mem.options.attachmentOptions.preattached, 'datasource.params', {});
                model[method]({}, {data: datasourceModel}).$promise.then((res) => { // eslint-disable-line no-unused-vars
                    if (mem.options.attachmentOptions.preattached.datasource.params.unique === res.unique) {
                        lodash.set(mem.inputData.model, 'attachments', res.data);
                    }
                    mem.options.attachmentOptions.preattached.loading = false;
                }, (err)=> {
                    console.log(err);
                    mem.options.attachmentOptions.preattached.loading = false;
                });
            }
        }

        function sync(vm) {
            vm.pageData = mem;
        }

        function destroy() {
            mem = {};
        }

        function selectType(activityType) {
            lodash.set(mem.inputData, 'model.type', activityType.value);
            lodash.set(mem.inputData, 'options', getActivityType(activityType.type));
            setModelDefaultValue(mem.inputData.options.elements);
            mem.currentActivityType = activityType;
            return mem.inputData.options;
        }

        function getActivityType(type) {
            return lodash.find(mem.options.activityTypes, function (at) {
                return at.type == type;
            });
        }

        function prepareInputData() {
            mem.inputData = {
                model: {},
                options: {
                    messageInput: {
                        preview_styles: true
                    }
                },
                inputOptions: lodash.get(mem.options, 'inputOptions', {})
            };
        }

        function save2(_model) {
            console.log('save model:', _model);
            mem.submitting = true;
            const activityType = lodash.find(mem.options.activityTypes, {type: mem.inputData.options.type});
            const props = [mem.options.inputOptions.descriptionName || 'description', 'type', 'attachments'].concat(lodash.get(activityType, 'schema', []));

            const modelData = {data: lodash.pick(mem.inputData.model, props)};

            // call remote api from here. API to be provided by the backend
            const model = new GenericModel(mem.options.inputOptions.datasource.url);
            const method = lodash.get(mem.options.inputOptions.datasource, 'method', 'post');
            const datasourceModel = lodash.get(mem.options.inputOptions.datasource, 'model', {});
            model[method](datasourceModel, modelData).$promise.then((res) => { // eslint-disable-line no-unused-vars
                // once submit, clear input model
                // refresh grid (need to store grid's callback in the activity-list side)
                mem.inputValidationErrorMessage = '';
                discard();
                refreshActivities();
                mem.submitting = false;
            }, (err)=> {
                mem.inputValidationErrorMessage = '';
                switch (err.status) {
                    case 422:
                        mem.inputValidationErrorMessage = lodash.flatMap(err.data.rules).join(', ');
                        break;
                }
                // mem.inputValidationError = err.data;
                console.warn(err); // eslint-disable-line no-console
                refreshActivities();
                mem.submitting = false;
            });
        }

        function save(data, type, options) {
            const resource = new GenericModel(options.datasource.url);
            const props = [lodash.get(options, 'descriptionName', 'txtbox_description'), 'attachments', 'hid_linked_id'].concat(lodash.get(type, 'schema', []));
            let model = { data: lodash.merge(lodash.pick(data, props), { type: type.value }) };
            const method = lodash.get(options.datasource, 'method', 'post');
            const params = lodash.get(options.datasource, 'model', {});
            const defaultModel = {data: lodash.get(options.datasource, 'defaultModel', {})};
            model = lodash.merge(defaultModel, model);
            return resource[method](params, model);
        }

        function discard() {
            mem.inputValidationErrorMessage = '';
            // mem.inputData.model = {};
            mem.discard();
        }

        function refreshActivities() {
            if (lodash.has(mem, 'activities.callback')) {
                try {
                    mem.activities.callback.dataSource.read();
                } catch (ex) {
                    console.warn(ex); // eslint-disable-line no-console
                }
            }
        }

        function setModelDefaultValue(elements) {
            lodash.forIn(elements, function (element) {
                const modelFieldName = ['model', element.name].join('.');
                if (!lodash.has(mem.inputData, modelFieldName)) {
                    lodash.set(mem.inputData, modelFieldName, getTypeDefaultValue(element));
                }
            });
        }

        function getTypeDefaultValue(element) {
            switch (element.type) {
                case 'select':
                    if (lodash.has(element, 'options.maxItems')) {
                        return (element.options.maxItems == null || element.options.maxItems > 1) ? [] : '';
                    } else {
                        return '';
                    }
                case 'datepicker':
                case 'timepicker':
                    return new Date();
                case 'text':
                    return lodash.get(element, 'value', '');
                case 'readonly':
                    return element.value;
            }
        }

        function setModel(field, value) {
            lodash.set(mem.inputData.model, field, value);
        }

        function inputOnChange(name, selectedValue) {
            //const inputElementOptions = lodash.get()
            const instructions = lodash.get(mem.options, 'inputOptions.onChangeInstructions', null);
            if (!!instructions) {
                const instruction = lodash.find(instructions, {name: name});
                if (!!instruction) {
                    execOnChangeInstructions(instruction.type, selectedValue);
                }
            }
        }

        function execOnChangeInstructions(type, data) {
            switch (type) {
                case 'setSignature': {
                    setSignature(data);
                    break;
                }
                default: {
                    break;
                }
            }
        }

        function setSignature(data) {
            // get the txt description field
            const regexSignature = /(<div\sclass=['"]signature-wrapper['"]>[\S\s]*<\/div>)/g;
            const fieldName = lodash.get(mem.options, 'inputOptions.signatureSettings.fieldName', false);
            if (!!fieldName) {
                let newData = '';
                let previousData = lodash.get(mem.inputData.model, fieldName, '');
                if (!previousData) {
                    previousData = '';
                }
                previousData = previousData.replace(regexSignature,'');

                // get signature
                const signatureId = lodash.get(data, 'signature.default', null);
                const signatureLists = lodash.get(data, 'signature.list', []);
                const signature = lodash.find(signatureLists, {id: signatureId});
                if (!!signature) {
                    const signatureHtml = '<p></p><div class="signature-wrapper">' + signature.signature + '</div>';
                    newData = previousData + signatureHtml;
                } else {
                    newData = previousData;
                }

                lodash.set(mem.inputData.model, fieldName, newData);

                // $rootScope.$apply();
            }
        }

        function getAttachmentOptions() {
            return lodash.get(mem, 'options.attachmentOptions', {});
        }
    }
})();

// set the datasource for activity list
// lodash.set(mem, 'options.activities', {
//     // data for testing
//     // for now will implement something simple. Will improve upon it once the actual data structure in the backend is finalized.
//     labels: {
//         activity_group_no_records: 'No records matching {0}',
//         cc: 'CC',
//         bcc: 'BCC',
//         guests: 'guests'
//     },
//     gridOptions: {
//         columns: [{
//             field: 'created_on',
//             groupHeaderTemplate: '<div><div class="activity-group-header-wrapper"><div class="activity-group-header" ng-bind="dataItem.value"></div></div><div class="activity-no-records" ng-if="dataItem.items.length == 0" ng-bind="vm.pageData.options.activities.labels.activity_group_no_records|stringFormat:[dataItem.value]"></div></div>',
//             template: '<rms-activity-wrapper item="dataItem"> <rms-activity item="dataItem" type="dataItem.type"></rms-activity> </rms-activity-wrapper>'
//         }],
//         pageable: {
//             pageSize: 2
//         }
//     },
//     data: {
//         total: 4,
//         groups: [
//             {
//                 field: 'created_on',
//                 hasSubGroup: false,
//                 aggregates: [],
//                 value: 'August 2016',
//                 items: [
//                     {
//                         type: 'email',
//                         created_on: '22/08/2016 at 10:42 AM GMT+8',
//                         created_by: {
//                             id: 123,
//                             name: 'Ryan'
//                         },
//                         description: '<a>You</a> have sent an email to <b>Fluffy</b> (fluffy@staffondemand.sg)',
//                         content: {
//                             description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.',
//                             subject: 'Lorem ipsum dolor sit amet.',
//                             cc: 'Hashy (hashy@staffondemand.sg), Xiao Zhu Zhu (xzz@staffondemand.sg)',
//                             bcc: 'Jagdish (jagdish@staffondemand.sg), Xiao Bupi(bupi@staffondemand.sg)'
//                         }
//
//                     },
//                     {
//                         type: 'log',
//                         created_on: '22/08/2016 at 10:42 AM GMT+8',
//                         created_by: {
//                             id: 123,
//                             name: 'Ryan',
//                             email: 'reccy84@gmail.com'
//                         },
//                         description: '<b>Fluffy</b> was shortlisted by <a>You</a> for <a>Pet</a>.'
//                     }
//                 ]
//             },
//             {
//                 field: 'created_on',
//                 hasSubGroup: false,
//                 aggregates: [],
//                 value: 'July 2016',
//                 items: []
//             },
//             {
//                 field: 'created_on',
//                 hasSubGroup: false,
//                 aggregates: [],
//                 value: 'June 2016',
//                 items: [
//                     {
//                         type: 'note',
//                         created_on: '22/08/2016 at 10:42 AM GMT+8',
//                         created_by: {
//                             id: 123,
//                             name: 'Ryan'
//                         },
//                         description: '<a>You</a> have created a note for <b>Fluffy</b>',
//                         content: {
//                             description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.'
//                         }
//                     },
//                     {
//                         type: 'schedule',
//                         created_on: '22/08/2016 at 10:42 AM GMT+8',
//                         created_by: {
//                             id: 123,
//                             name: 'Ryan'
//                         },
//                         description: '<a>You</a> have scheduled an interview for <b>Fluffy</b>',
//                         content: {
//                             name: 'Interview with Fluffy',
//                             date: '23/08/2016 at 10:00 AM GMT+8',
//                             description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.',
//                             guests: [
//                                 {
//                                     description: 'Ryan (ryan@staffondemand.sg)',
//                                     email: 'reccy84@gmail.com',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Bupi (xbupi@staffondemand.sg)',
//                                     email: 'xbupi@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Fluffy (xfluffy@staffondemand.sg)',
//                                     email: 'xfluffy@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Hashy (xhashy@staffondemand.sg)',
//                                     email: 'xhashy@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Snowy (xsnowy@staffondemand.sg)',
//                                     email: 'xsnowy@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Wahabi (xwahabi@staffondemand.sg)',
//                                     email: 'xwahabi@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Dusty (xdusty@staffondemand.sg)',
//                                     email: 'xdusty@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Zhuzhu (xzhuzhu@staffondemand.sg)',
//                                     email: 'xzhuzhu@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Burrito (xburrito@staffondemand.sg)',
//                                     email: 'xburrito@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Ham (xham@staffondemand.sg)',
//                                     email: 'xham@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Tweenie (xtweenie@staffondemand.sg)',
//                                     email: 'xtweenie@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'HoneyPot (xhoneypot@staffondemand.sg)',
//                                     email: 'xhoneypot@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Hearty (xhearty@staffondemand.sg)',
//                                     email: 'xhearty@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 }
//                             ]
//                         }
//                     }
//                 ]
//             }
//         ]
//     },
//     // actual implementation should use datasource
//     datasource: {
//         read: {},
//         filter: {}
//     },
//     datasourceOptions: {
//         serverGrouping: true,
//         group: {field: 'created_on', dir: 'asc'},
//         schema: {
//             //data: 'content',
//             groups: 'groups',
//             total: 'total'
//         }
//     },
//     filters: {
//         types: {
//             filter: {
//                 datasource: {
//                     init: {
//                         url: 'api/v1/structure/rms/contacts/filter',
//                         method: 'get'
//                     }
//                 }
//             },
//             sort: {
//                 sort_list: [
//                     {label: 'Created On', name: 'created_on', default_direction: 'desc'},
//                     {label: 'Type', name: 'type', default_direction: 'asc'}
//                 ],
//                 selected_sort_template: '<div class="active">{0} <i class="fa {1}"></i></div>'
//             },
//             search: {
//                 field_name: 'filter_search_text',
//                 operator: 'contains',
//                 search_icon: '',
//                 use_icon: true,
//                 icon: 'fa-search',
//                 search_on_change: true,
//                 model_options: {debounce: 300}
//             },
//             reset: true
//         },
//         labels: {
//             'no_operator_selected': 'Can you select something, please?',
//             'no_value_set': 'Can you provide a value, please?',
//             'apply_button': 'Apply',
//             'cancel_button': 'Cancel',
//             'filter': 'Filter',
//             'sort': 'Sort',
//             'search': 'Search'
//         }
//     }
// });


// lodash.set(mem, 'options.activities.data', {
//     total: 4,
//     groups: [
//         {
//             field: 'created_on',
//             hasSubGroup: false,
//             aggregates: [],
//             value: 'August 2016',
//             items: [
//                 {
//                     type: 'email',
//                     created_on: '22/08/2016 at 10:42 AM GMT+8',
//                     created_by: {
//                         id: 123,
//                         name: 'Ryan'
//                     },
//                     description: '<a>You</a> have sent an email to <b>Fluffy</b> (fluffy@staffondemand.sg)',
//                     content: {
//                         description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.',
//                         subject: 'Lorem ipsum dolor sit amet.',
//                         cc: 'Hashy (hashy@staffondemand.sg), Xiao Zhu Zhu (xzz@staffondemand.sg)',
//                         bcc: 'Jagdish (jagdish@staffondemand.sg), Xiao Bupi(bupi@staffondemand.sg)'
//                     }
//
//                 },
//                 {
//                     type: 'log',
//                     created_on: '22/08/2016 at 10:42 AM GMT+8',
//                     created_by: {
//                         id: 123,
//                         name: 'Ryan',
//                         email: 'reccy84@gmail.com'
//                     },
//                     description: '<b>Fluffy</b> was shortlisted by <a>You</a> for <a>Pet</a>.'
//                 }
//             ]
//         },
//         {
//             field: 'created_on',
//             hasSubGroup: false,
//             aggregates: [],
//             value: 'July 2016',
//             items: []
//         },
//         {
//             field: 'created_on',
//             hasSubGroup: false,
//             aggregates: [],
//             value: 'June 2016',
//             items: [
//                 {
//                     type: 'note',
//                     created_on: '22/08/2016 at 10:42 AM GMT+8',
//                     created_by: {
//                         id: 123,
//                         name: 'Ryan'
//                     },
//                     description: '<a>You</a> have created a note for <b>Fluffy</b>',
//                     content: {
//                         description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.'
//                     }
//                 },
//                 {
//                     type: 'schedule',
//                     created_on: '22/08/2016 at 10:42 AM GMT+8',
//                     created_by: {
//                         id: 123,
//                         name: 'Ryan'
//                     },
//                     description: '<a>You</a> have scheduled an interview for <b>Fluffy</b>',
//                     content: {
//                         name: 'Interview with Fluffy',
//                         date: '23/08/2016 at 10:00 AM GMT+8',
//                         description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.',
//                         guests: [
//                             {
//                                 description: 'Ryan (ryan@staffondemand.sg)',
//                                 email: 'reccy84@gmail.com',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Bupi (xbupi@staffondemand.sg)',
//                                 email: 'xbupi@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Fluffy (xfluffy@staffondemand.sg)',
//                                 email: 'xfluffy@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Hashy (xhashy@staffondemand.sg)',
//                                 email: 'xhashy@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Snowy (xsnowy@staffondemand.sg)',
//                                 email: 'xsnowy@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Wahabi (xwahabi@staffondemand.sg)',
//                                 email: 'xwahabi@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Dusty (xdusty@staffondemand.sg)',
//                                 email: 'xdusty@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Zhuzhu (xzhuzhu@staffondemand.sg)',
//                                 email: 'xzhuzhu@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Burrito (xburrito@staffondemand.sg)',
//                                 email: 'xburrito@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Ham (xham@staffondemand.sg)',
//                                 email: 'xham@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Tweenie (xtweenie@staffondemand.sg)',
//                                 email: 'xtweenie@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'HoneyPot (xhoneypot@staffondemand.sg)',
//                                 email: 'xhoneypot@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Hearty (xhearty@staffondemand.sg)',
//                                 email: 'xhearty@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             }
//                         ]
//                     }
//                 }
//             ]
//         }
//     ]
//
// });


// set the input stuff
// input endpoints
// lodash.set(mem, 'options.inputOptions', {
//     datasource: {
//         url: 'abc',
//         method: 'post'
//     },
//     descriptionName: 'txtbox_description'
// });

// if you don't provide activityTypes, The input will never show.
/*lodash.set(mem, 'options.activityTypes', [
 {
 labels: {
 title: 'Email',
 to: 'To',
 from: 'From',
 subject: 'Subject',
 cc: 'CC',
 bcc: 'BCC',
 buttonCreate: 'Send',
 buttonCancel: 'Discard'
 },
 value: 'email',
 icon: 'envelope',
 schema: ['to', 'from', 'cc', 'bcc', 'subject'],
 type: 'email',
 elements: {
 to: {
 name: 'to',
 value: "fluffyxiao@staffondemand.sg",
 type: "text",
 options: {
 readonly: true
 }
 },
 from: {
 name: 'from',
 value: "ryan@staffondemand.sg",
 type: "text",
 options: {
 readonly: true
 }
 },
 subject: {
 name: 'subject',
 type: "text"
 },
 cc: {
 name: 'cc',
 type: "select",
 datasource: {
 data: [
 {label: 'Ryan Oh (ryan@staffondemand.sg)', value: 'test1'},
 {label: 'Jagdish (jagdish@staffondemand.sg)', value: 'test2'},
 {label: 'Fluffy (fluffy@staffondemand.sg)', value: 'test3'},
 {label: 'Hashy (hashy@staffondemand.sg)', value: 'test3'}
 ]
 },
 options: {
 maxItems: null
 }
 },
 bcc: {
 name: 'bcc',
 type: "select",
 datasource: {
 data: [
 {label: 'Ryan Oh (ryan@staffondemand.sg)', value: 'test1'},
 {label: 'Jagdish (jagdish@staffondemand.sg)', value: 'test2'},
 {label: 'Fluffy (fluffy@staffondemand.sg)', value: 'test3'},
 {label: 'Hashy (hashy@staffondemand.sg)', value: 'test3'}
 ]
 },
 options: {
 maxItems: null
 }
 }
 }
 },
 {
 labels: {
 title: 'Log Activity',
 buttonCreate: 'Create',
 buttonCancel: 'Cancel'
 },
 value: 'log',
 icon: 'envelope',
 schema: ['activity_date', 'activity_time', 'log_type'],
 type: 'timestamp',
 elements: {
 select: {
 type: "select",
 label: "Type",
 name: 'log_type',
 datasource: {
 data: [
 {label: 'Test1', value: 'test1'},
 {label: 'Test2', value: 'test2'},
 {label: 'Test3', value: 'test3'}
 ]
 },
 options: {}
 },
 activity_date: {
 name: 'activity_date',
 type: 'datepicker'
 },
 activity_time: {
 name: 'activity_time',
 type: 'timepicker'
 }
 }
 },
 {
 value: 'note', icon: 'envelope', type: 'normal',
 labels: {
 title: 'Note',
 buttonCreate: 'Save Task',
 buttonCancel: 'Cancel'
 }
 },
 {
 value: 'schedule', icon: 'envelope', type: 'scheduler',
 labels: {
 title: 'Schedule',
 eventName: 'Event Name',
 startDateTime: 'Starts',
 endDateTime: 'Ends',
 guests: 'Invitees',
 buttonCreate: 'Create',
 buttonCancel: 'Cancel',
 inputTitle:'Event Description Label'
 },
 schema: ['start_date', 'start_time', 'end_date','end_time','event_name',''],
 // inputTitle: 'Event Description',
 elements: {
 start_date: {
 name: 'start_date',
 type: 'datepicker'
 },
 start_time: {
 name: 'start_time',
 type: 'timepicker'
 },
 end_date: {
 name: 'end_date',
 type: 'datepicker'
 },
 end_time: {
 name: 'end_time',
 type: 'timepicker'
 },
 event_name: {
 name: 'event_name',
 type: "text"
 },
 invitee: {
 type: "custom-select",
 label: "Type",
 name: 'invitee',
 datasource: {
 data: [
 {name: 'Ryan', email: 'ryan@staffondemand.sg', department: 'IT', id: 1},
 {name: 'Jagdish', email: 'jagdish@staffondemand.sg', department: 'IT', id: 2},
 {name: 'Fluffy', email: 'fluffy@staffondemand.sg', department: 'Pet', id: 3},
 {name: 'Bupi', email: 'hashy@staffondemand.sg', department: 'Pet', id: 4},
 {name: 'Hashy', email: 'hashy@staffondemand.sg', department: 'Pet', id: 5},
 {name: 'Snowy', email: 'hashy@staffondemand.sg', department: 'Pet', id: 6},
 {name: 'Dusty', email: 'hashy@staffondemand.sg', department: 'Pet', id: 7},
 {name: 'Wahabi', email: 'hashy@staffondemand.sg', department: 'Pet', id: 8},
 {name: 'Zhuzhu', email: 'hashy@staffondemand.sg', department: 'Pet', id: 9},
 {name: 'Hearty', email: 'hashy@staffondemand.sg', department: 'Pet', id: 10},
 {name: 'Burrito', email: 'hashy@staffondemand.sg', department: 'Pet', id: 11},
 {name: 'HoneyPot', email: 'hashy@staffondemand.sg', department: 'Pet', id: 12},
 {name: 'Tweenie', email: 'hashy@staffondemand.sg', department: 'Pet', id: 13},
 {name: 'Ham', email: 'hashy@staffondemand.sg', department: 'Pet', id: 14}
 ]
 },
 options: {
 maxItems: null,
 labelField: 'email',
 valueField: 'id',
 searchField: ['name', 'email', 'department'],
 placeholder: 'Click here to add invitees',
 template: {
 item: {
 html: '<div>#name# (#email#)</div>',
 schema: ['name', 'email']
 },
 option: {
 html: '<div><h6>#name#</h6><div>#email#</div><div>#department#</div></div>',
 schema: ['name', 'email', 'department']
 }
 }
 }
 }
 }
 }
 ]);
 */
